import { useAsyncDataRequestStatus } from '@/wabunka-src/common/composables';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';
import { createDefaultFeaturedState, type FeaturedViewModel } from '@/wabunka-src/common/features';
import type { microCMSDraftKeyQuery } from '@/wabunka-src/common/models/microCMS';

import type { AsyncDataRequestStatus } from 'nuxt/app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object, server?: boolean) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '') + (server ? ',server' : ',client');
};

/**
 * 英語版テーマ詳細の取得に使用する Composable
 * Page でのみ使用可能
 */
export const useGetThemeQuery = async (contentId: string, draftKeyQuery: microCMSDraftKeyQuery, server: boolean = false) => {
  const filters = 'type[equals]theme';
  const { data, status }: { data: Ref<FeaturedViewModel | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<FeaturedViewModel>(
    {
      endpoint: 'en-featured',
      contentId,
      queries: { ...draftKeyQuery, filters },
    },
    {
      key: buildKey('en-featured', { contentId, ...draftKeyQuery }, server),
      server: server,
    },
  );

  const enTheme = computed<FeaturedViewModel>(() => data.value || createDefaultFeaturedState());

  return { enTheme, ...useAsyncDataRequestStatus(status) };
};
